import styled from '@emotion/styled';

import FlexContainer from '~/components/Layout/FlexContainer';

const Row = styled(FlexContainer)`
  margin-bottom: 10px;
`;

interface ColumnProps {
  width: string;
}

const Column = styled('div')<ColumnProps>`
  flex-basis: ${(props) => props.width};
  margin-right: 15px;

  &:last-of-type {
    margin-right: 0px;
  }
`;

export { Column, Row };
